// Generated by packages/tokens/build.js — do not edit.
export const tokens = {
  "color": {
    "bordo": "#990000",
    "preto": "#000000",
    "branco": "#ffffff",
    "cinza": {
      "k10": "#e6e6e6",
      "k20": "#cccccc",
      "k30": "#b3b3b3",
      "k40": "#999999",
      "k50": "#808080",
      "k60": "#666666",
      "k70": "#4d4d4d",
      "k80": "#333333",
      "k90": "#1a1a1a"
    },
    "brand": {
      "primary": "#990000",
      "contrast": "#ffffff",
      "ink": "#000000"
    },
    "surface": {
      "default": "#ffffff",
      "muted": "#e6e6e6",
      "inverse": "#000000"
    },
    "text": {
      "default": "#000000",
      "muted": "#666666",
      "inverse": "#ffffff",
      "brand": "#990000"
    },
    "border": {
      "default": "#e6e6e6",
      "strong": "#b3b3b3"
    }
  },
  "space": {
    "1": "8px",
    "2": "16px",
    "3": "24px",
    "4": "32px",
    "6": "48px",
    "8": "64px",
    "x": "8px"
  },
  "mark": {
    "ratio": {
      "width": 1,
      "height": 1.5
    },
    "sigla": {
      "width": 0.7,
      "gap": 0.23,
      "rule": 0.1
    },
    "extenso": {
      "width": 1.2,
      "gap": 0.53,
      "rule": 0.0833
    }
  },
  "font": {
    "family": {
      "sans": "Trebuchet MS, Lucida Grande, Tahoma, sans-serif"
    },
    "weight": {
      "normal": 400,
      "bold": 700
    },
    "size": {
      "xs": "12px",
      "sm": "14px",
      "base": "16px",
      "md": "18px",
      "lg": "24px",
      "xl": "32px",
      "2xl": "44px"
    }
  },
  "typography": {
    "body": {
      "fontFamily": "Trebuchet MS, Lucida Grande, Tahoma, sans-serif",
      "fontWeight": "400",
      "fontSize": "16px",
      "lineHeight": 1.55
    },
    "heading": {
      "fontFamily": "Trebuchet MS, Lucida Grande, Tahoma, sans-serif",
      "fontWeight": "700",
      "fontSize": "32px",
      "lineHeight": 1.2,
      "letterSpacing": "-0.01em"
    },
    "versalete": {
      "fontFamily": "Trebuchet MS, Lucida Grande, Tahoma, sans-serif",
      "fontWeight": "700",
      "fontSize": "16px",
      "fontVariantCaps": "small-caps",
      "textTransform": "lowercase",
      "letterSpacing": "0.04em"
    }
  }
};
export default tokens;
